import React, { Component } from 'react'
 class FirstComponent extends Component {
    render(){
    return (
      <div className="firstComponent">
            HELLO MY WORLD !!!!....
      </div>
    )
  }
  }
  export default FirstComponent